import { useEffect } from "react"
import dayjs from "dayjs"

import { useLazyGetUserProfileQuery } from "store/api/profileApi"
import { useAppDispatch } from "store/hooks"
import { setUserActiveTheme, setUserLogo } from "store/tempDataSlise"
import { setUserProfile } from "store/userSlise"
import { ApiTypes } from "types"
import { StorageKeys } from "types/enums/StorageKeys"
import SubscriptionPlan from "types/enums/SubscriptionPlan"

import { UserRole } from "utils/checkRoleType"
import { getStorageItem, setStorageItem } from "utils/localStorage"
const useUserProfileSync = () => {
  const dispatch = useAppDispatch()
  const [triggerGetProfile] = useLazyGetUserProfileQuery()

  const getProfile = async () => {
    try {
      const res = await triggerGetProfile()

      if (res && !res.error) {
        const lastSync = dayjs()
        setStorageItem(StorageKeys.UserProfile, { ...res?.data?.data, lastSync } as ApiTypes.Model.UserProfile)
        dispatch(setUserProfile(res?.data?.data ? { ...res?.data?.data, lastSync } : null))

        const canUseCustomTheme =
          res?.data?.data?.contractor?.subscription_plan === SubscriptionPlan.E_PLUS ||
          res?.data?.data?.type === UserRole.EnterpriseManager

        if (!canUseCustomTheme) {
          dispatch(setUserActiveTheme("default"))
          dispatch(setUserLogo())
        }
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      const jsonUserProfile = getStorageItem(StorageKeys.UserProfile)
      if (!jsonUserProfile || typeof jsonUserProfile !== "object") return

      const userProfile = {
        ...jsonUserProfile,
        lastSync: jsonUserProfile.lastSync ? dayjs(jsonUserProfile.lastSync) : dayjs().year(2000),
      }

      if (dayjs().diff(userProfile.lastSync, "minute") > 30) {
        getProfile()
      }
    }, 15000)

    return () => {
      clearInterval(interval)
    }
  }, [])
}

export default useUserProfileSync
